/** Rubro fisioterapia — utilidades compartidas para cualquier tenant cliente. */

import { resolveDisplayName, type TenantBranding } from './branding.svelte';

export const ORG_FISIOTERAPIA = 'clinica-fisioterapia';

/** Solo demo sembrada; en producción use {@link autorFisioterapista}. */
export const FISIO_PROFESIONAL_DEMO = 'Fisioterapista Demo';

export function isClinicaFisioterapia(org: string | null | undefined): boolean {
  return org === ORG_FISIOTERAPIA;
}

/** Nombre del profesional que atiende (cualquier tenant). */
export function autorFisioterapista(opts?: {
  profesional?: string | null;
  usuario?: string | null;
}): string {
  const profesional = opts?.profesional?.trim();
  if (profesional) return profesional;
  const usuario = opts?.usuario?.trim();
  if (usuario && !usuario.includes('@')) return usuario;
  return 'Fisioterapista';
}

/** Marca comercial del tenant para WhatsApp, recibos y mensajes al paciente. */
export function nombreClinicaCliente(
  branding: TenantBranding | null | undefined,
  tenantNombre: string | null | undefined,
  tenantId: string,
): string {
  return resolveDisplayName(branding, tenantNombre, tenantId);
}

/** Campos legacy (signos vitales re-etiquetados). Preferir {@link fisioterapia-evaluaciones}. */
export const SIGNOS_FISIO_LABELS = {
  ta: 'EVA dolor (0–10)',
  fc: 'ROM flexión (°)',
  fr: 'ROM abducción (°)',
  temp: 'Fuerza MMT (0–5)',
  satO2: 'Índice funcional',
  peso: 'Perímetro (cm)',
  talla: 'Observaciones',
} as const;

export const NOTA_FISIO_PLACEHOLDER =
  'Sesión N/M · Subjetivo · Objetivo (EVA, ROM) · Modalidades (TENS, US, masaje, movilización) · Ejercicios domiciliarios (series/reps) · Plan próxima sesión';

/** Modalidades habituales en clínicas de rehabilitación (referencia clínica). */
export const FISIO_MODALIDADES = [
  'Masaje terapéutico',
  'Movilización articular',
  'Electroterapia (TENS / IFT)',
  'Ultrasonido terapéutico',
  'Termoterapia / crioterapia',
  'Ejercicio terapéutico',
  'Vendaje / kinesiotape',
] as const;
